<template lang="pug">
  v-select(
    v-model="p_code"
    :items="filterList"
    item-text="label"
    item-value="code"
    :clearable="clearable"
    label="受注希望"
    :error-messages="errorHandlerMethod(errorHandlerMethodArgComputed)")
</template>

<script>
export default {
  props: {
    code: {
      type: [String, Number],
      default: null
    },
    errorHandlerMethod: {
      type: Function,
      default() {
        return null;
      }
    },
    errorHandlerMethodArg: {
      type: String,
      default() {
        return null;
      }
    },
    clearable: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      defaultErrorHandlerMethodArg: "applicantFilter",
      filterList: [
        { code: "1", label: "自分" },
        { code: "2", label: "所属部署" }
      ]
    };
  },
  computed: {
    p_code: {
      get() {
        return this.code;
      },
      set(newVal) {
        if (this.code !== newVal) this.$emit("update:code", newVal);
      }
    },
    errorHandlerMethodArgComputed: {
      get() {
        if (this.errorHandlerMethodArg == null) {
          return this.defaultErrorHandlerMethodArg;
        }
        return this.errorHandlerMethodArg;
      }
    }
  }
};
</script>

<style scoped></style>
